// Copy for blind sessions (docs/design/social-plan.md, phase 7): the per-person strip, what the room
// said about a wine once it is shown, the standings, and a group's weekly co-op goal. One entry per
// locale; every key exists in all seven (nl is the source, the rest are translations). The numbers in
// the rules line come from the domain's point values, so the words never drift from the scoring.
export const blindCopy = {
  nl: {
    "blind.flight.badge": "Blind",
    "blind.strip.title": "Per deelnemer",
    "blind.strip.row": "{done} van {total} ingediend",
    "blind.strip.cell.waiting": "nog niets",
    "blind.strip.cell.submitted": "ingediend",
    "blind.strip.cell.silent": "ingediend, geen gok",
    "blind.strip.cell.correct": "goed geraden",
    "blind.strip.cell.wrong": "mis geraden",
    "blind.calls.title": "Wat de groep zei over wijn {n}",
    "blind.calls.none": "Niemand deed een gok bij deze wijn.",
    "blind.calls.grape.correct": "Druif goed",
    "blind.calls.grape.wrong": "Druif fout",
    "blind.calls.country.correct": "Land goed",
    "blind.calls.country.wrong": "Land fout",
    "blind.standings.title": "Tussenstand",
    "blind.standings.final": "Eindstand",
    "blind.standings.row": "Gokken: {calls}, goed: {correct}",
    "blind.standings.points": "{points} pnt",
    "blind.standings.rule":
      "Druif goed telt {grape} punten, land goed {country}. Fout geraden kost niets.",
    "blind.results.open": "Bekijk de resultaten",
    "blind.goal.title": "Weekdoel",
    "blind.goal.none.member": "Nog geen weekdoel. Een beheerder kan er een kiezen.",
    "blind.goal.none.manager":
      "Nog geen weekdoel. Kies hoeveel blinde gokken de groep deze week samen wil doen.",
    "blind.goal.progress": "{calls} van {target} blinde gokken deze week",
    "blind.goal.reached": "Gehaald!",
    "blind.goal.remaining": "Nog {n} te gaan",
    "blind.goal.correct": "waarvan {n} goed",
    "blind.goal.contributors": "Meegedaan",
    "blind.goal.target.label": "Doel per week",
    "blind.goal.target": "{n} gokken",
    "blind.goal.off": "Weekdoel uitzetten",
    "blind.goal.hint":
      "Telt de blinde gokken van iedereen in proeverijen van deze groep. Elke maandag begint de telling opnieuw.",
    "blind.goal.error": "Het weekdoel kon niet worden opgeslagen.",
    "social.groups.log.goal": "De groep haalde het weekdoel van {target} blinde gokken",
    "social.groups.log.goal.plain": "De groep haalde het weekdoel",
  },
  en: {
    "blind.flight.badge": "Blind",
    "blind.strip.title": "By taster",
    "blind.strip.row": "{done} of {total} in",
    "blind.strip.cell.waiting": "nothing yet",
    "blind.strip.cell.submitted": "in",
    "blind.strip.cell.silent": "in, no call",
    "blind.strip.cell.correct": "called right",
    "blind.strip.cell.wrong": "called wrong",
    "blind.calls.title": "What the group said about wine {n}",
    "blind.calls.none": "Nobody made a call on this wine.",
    "blind.calls.grape.correct": "Grape right",
    "blind.calls.grape.wrong": "Grape wrong",
    "blind.calls.country.correct": "Country right",
    "blind.calls.country.wrong": "Country wrong",
    "blind.standings.title": "Standings so far",
    "blind.standings.final": "Final standings",
    "blind.standings.row": "Calls: {calls}, right: {correct}",
    "blind.standings.points": "{points} pts",
    "blind.standings.rule":
      "The grape right is worth {grape} points, the country right {country}. A miss costs nothing.",
    "blind.results.open": "See the results",
    "blind.goal.title": "Weekly goal",
    "blind.goal.none.member": "No weekly goal yet. An admin can pick one.",
    "blind.goal.none.manager":
      "No weekly goal yet. Pick how many blind calls the group wants to make together this week.",
    "blind.goal.progress": "{calls} of {target} blind calls this week",
    "blind.goal.reached": "Reached!",
    "blind.goal.remaining": "{n} to go",
    "blind.goal.correct": "{n} of them right",
    "blind.goal.contributors": "Took part",
    "blind.goal.target.label": "Goal per week",
    "blind.goal.target": "{n} calls",
    "blind.goal.off": "Turn the weekly goal off",
    "blind.goal.hint":
      "Counts everyone's blind calls in this group's tastings. The count starts again every Monday.",
    "blind.goal.error": "The weekly goal could not be saved.",
    "social.groups.log.goal": "The group reached its weekly goal of {target} blind calls",
    "social.groups.log.goal.plain": "The group reached its weekly goal",
  },
  de: {
    "blind.flight.badge": "Blind",
    "blind.strip.title": "Pro Teilnehmer",
    "blind.strip.row": "{done} von {total} abgegeben",
    "blind.strip.cell.waiting": "noch nichts",
    "blind.strip.cell.submitted": "abgegeben",
    "blind.strip.cell.silent": "abgegeben, kein Tipp",
    "blind.strip.cell.correct": "richtig getippt",
    "blind.strip.cell.wrong": "falsch getippt",
    "blind.calls.title": "Was die Gruppe zu Wein {n} sagte",
    "blind.calls.none": "Niemand hat bei diesem Wein getippt.",
    "blind.calls.grape.correct": "Rebsorte richtig",
    "blind.calls.grape.wrong": "Rebsorte falsch",
    "blind.calls.country.correct": "Land richtig",
    "blind.calls.country.wrong": "Land falsch",
    "blind.standings.title": "Zwischenstand",
    "blind.standings.final": "Endstand",
    "blind.standings.row": "Tipps: {calls}, richtig: {correct}",
    "blind.standings.points": "{points} Pkt.",
    "blind.standings.rule":
      "Die richtige Rebsorte zählt {grape} Punkte, das richtige Land {country}. Falsch getippt kostet nichts.",
    "blind.results.open": "Ergebnisse ansehen",
    "blind.goal.title": "Wochenziel",
    "blind.goal.none.member": "Noch kein Wochenziel. Ein Admin kann eines wählen.",
    "blind.goal.none.manager":
      "Noch kein Wochenziel. Wähle, wie viele Blindtipps die Gruppe diese Woche gemeinsam abgeben will.",
    "blind.goal.progress": "{calls} von {target} Blindtipps diese Woche",
    "blind.goal.reached": "Geschafft!",
    "blind.goal.remaining": "Noch {n} bis zum Ziel",
    "blind.goal.correct": "davon {n} richtig",
    "blind.goal.contributors": "Dabei",
    "blind.goal.target.label": "Ziel pro Woche",
    "blind.goal.target": "{n} Tipps",
    "blind.goal.off": "Wochenziel ausschalten",
    "blind.goal.hint":
      "Zählt die Blindtipps aller in den Verkostungen dieser Gruppe. Jeden Montag beginnt die Zählung neu.",
    "blind.goal.error": "Das Wochenziel konnte nicht gespeichert werden.",
    "social.groups.log.goal": "Die Gruppe hat ihr Wochenziel von {target} Blindtipps erreicht",
    "social.groups.log.goal.plain": "Die Gruppe hat ihr Wochenziel erreicht",
  },
  fr: {
    "blind.flight.badge": "À l'aveugle",
    "blind.strip.title": "Par participant",
    "blind.strip.row": "{done} sur {total} rendues",
    "blind.strip.cell.waiting": "rien encore",
    "blind.strip.cell.submitted": "rendue",
    "blind.strip.cell.silent": "rendue, sans pari",
    "blind.strip.cell.correct": "bien deviné",
    "blind.strip.cell.wrong": "mal deviné",
    "blind.calls.title": "Ce que le groupe a dit du vin {n}",
    "blind.calls.none": "Personne n'a deviné ce vin.",
    "blind.calls.grape.correct": "Cépage juste",
    "blind.calls.grape.wrong": "Cépage faux",
    "blind.calls.country.correct": "Pays juste",
    "blind.calls.country.wrong": "Pays faux",
    "blind.standings.title": "Classement provisoire",
    "blind.standings.final": "Classement final",
    "blind.standings.row": "Paris : {calls}, justes : {correct}",
    "blind.standings.points": "{points} pts",
    "blind.standings.rule":
      "Le bon cépage vaut {grape} points, le bon pays {country}. Se tromper ne coûte rien.",
    "blind.results.open": "Voir les résultats",
    "blind.goal.title": "Objectif de la semaine",
    "blind.goal.none.member": "Pas encore d'objectif. Un admin peut en choisir un.",
    "blind.goal.none.manager":
      "Pas encore d'objectif. Choisis combien de paris à l'aveugle le groupe veut faire ensemble cette semaine.",
    "blind.goal.progress": "{calls} sur {target} paris à l'aveugle cette semaine",
    "blind.goal.reached": "Atteint !",
    "blind.goal.remaining": "Encore {n}",
    "blind.goal.correct": "dont {n} justes",
    "blind.goal.contributors": "Ont joué",
    "blind.goal.target.label": "Objectif par semaine",
    "blind.goal.target": "{n} paris",
    "blind.goal.off": "Désactiver l'objectif",
    "blind.goal.hint":
      "Compte les paris à l'aveugle de tous lors des dégustations de ce groupe. Le compte repart chaque lundi.",
    "blind.goal.error": "L'objectif n'a pas pu être enregistré.",
    "social.groups.log.goal": "Le groupe a atteint son objectif de {target} paris à l'aveugle",
    "social.groups.log.goal.plain": "Le groupe a atteint son objectif de la semaine",
  },
  es: {
    "blind.flight.badge": "A ciegas",
    "blind.strip.title": "Por participante",
    "blind.strip.row": "{done} de {total} entregadas",
    "blind.strip.cell.waiting": "nada aún",
    "blind.strip.cell.submitted": "entregada",
    "blind.strip.cell.silent": "entregada, sin apuesta",
    "blind.strip.cell.correct": "acertó",
    "blind.strip.cell.wrong": "falló",
    "blind.calls.title": "Lo que dijo el grupo del vino {n}",
    "blind.calls.none": "Nadie apostó por este vino.",
    "blind.calls.grape.correct": "Uva acertada",
    "blind.calls.grape.wrong": "Uva errada",
    "blind.calls.country.correct": "País acertado",
    "blind.calls.country.wrong": "País errado",
    "blind.standings.title": "Clasificación provisional",
    "blind.standings.final": "Clasificación final",
    "blind.standings.row": "Apuestas: {calls}, acertadas: {correct}",
    "blind.standings.points": "{points} pts",
    "blind.standings.rule":
      "Acertar la uva vale {grape} puntos, acertar el país {country}. Fallar no cuesta nada.",
    "blind.results.open": "Ver los resultados",
    "blind.goal.title": "Objetivo semanal",
    "blind.goal.none.member": "Aún no hay objetivo semanal. Un admin puede elegir uno.",
    "blind.goal.none.manager":
      "Aún no hay objetivo semanal. Elige cuántas apuestas a ciegas quiere hacer el grupo esta semana.",
    "blind.goal.progress": "{calls} de {target} apuestas a ciegas esta semana",
    "blind.goal.reached": "¡Conseguido!",
    "blind.goal.remaining": "Faltan {n}",
    "blind.goal.correct": "{n} acertadas",
    "blind.goal.contributors": "Han participado",
    "blind.goal.target.label": "Objetivo por semana",
    "blind.goal.target": "{n} apuestas",
    "blind.goal.off": "Desactivar el objetivo semanal",
    "blind.goal.hint":
      "Cuenta las apuestas a ciegas de todos en las catas de este grupo. La cuenta vuelve a empezar cada lunes.",
    "blind.goal.error": "No se pudo guardar el objetivo semanal.",
    "social.groups.log.goal":
      "El grupo ha conseguido su objetivo semanal de {target} apuestas a ciegas",
    "social.groups.log.goal.plain": "El grupo ha conseguido su objetivo semanal",
  },
  it: {
    "blind.flight.badge": "Alla cieca",
    "blind.strip.title": "Per partecipante",
    "blind.strip.row": "{done} su {total} consegnate",
    "blind.strip.cell.waiting": "ancora niente",
    "blind.strip.cell.submitted": "consegnata",
    "blind.strip.cell.silent": "consegnata, nessuna ipotesi",
    "blind.strip.cell.correct": "indovinato",
    "blind.strip.cell.wrong": "sbagliato",
    "blind.calls.title": "Cosa ha detto il gruppo sul vino {n}",
    "blind.calls.none": "Nessuno ha fatto un'ipotesi su questo vino.",
    "blind.calls.grape.correct": "Vitigno giusto",
    "blind.calls.grape.wrong": "Vitigno sbagliato",
    "blind.calls.country.correct": "Paese giusto",
    "blind.calls.country.wrong": "Paese sbagliato",
    "blind.standings.title": "Classifica provvisoria",
    "blind.standings.final": "Classifica finale",
    "blind.standings.row": "Ipotesi: {calls}, giuste: {correct}",
    "blind.standings.points": "{points} pt",
    "blind.standings.rule":
      "Il vitigno giusto vale {grape} punti, il paese giusto {country}. Sbagliare non costa nulla.",
    "blind.results.open": "Vedi i risultati",
    "blind.goal.title": "Obiettivo settimanale",
    "blind.goal.none.member": "Nessun obiettivo settimanale. Un admin può sceglierne uno.",
    "blind.goal.none.manager":
      "Nessun obiettivo settimanale. Scegli quante ipotesi alla cieca vuole fare il gruppo insieme questa settimana.",
    "blind.goal.progress": "{calls} su {target} ipotesi alla cieca questa settimana",
    "blind.goal.reached": "Raggiunto!",
    "blind.goal.remaining": "Ne mancano {n}",
    "blind.goal.correct": "di cui {n} giuste",
    "blind.goal.contributors": "Hanno partecipato",
    "blind.goal.target.label": "Obiettivo a settimana",
    "blind.goal.target": "{n} ipotesi",
    "blind.goal.off": "Disattiva l'obiettivo settimanale",
    "blind.goal.hint":
      "Conta le ipotesi alla cieca di tutti nelle degustazioni di questo gruppo. Il conteggio riparte ogni lunedì.",
    "blind.goal.error": "Non è stato possibile salvare l'obiettivo settimanale.",
    "social.groups.log.goal":
      "Il gruppo ha raggiunto l'obiettivo settimanale di {target} ipotesi alla cieca",
    "social.groups.log.goal.plain": "Il gruppo ha raggiunto l'obiettivo settimanale",
  },
  pt: {
    "blind.flight.badge": "Às cegas",
    "blind.strip.title": "Por participante",
    "blind.strip.row": "{done} de {total} entregues",
    "blind.strip.cell.waiting": "ainda nada",
    "blind.strip.cell.submitted": "entregue",
    "blind.strip.cell.silent": "entregue, sem palpite",
    "blind.strip.cell.correct": "acertou",
    "blind.strip.cell.wrong": "errou",
    "blind.calls.title": "O que o grupo disse sobre o vinho {n}",
    "blind.calls.none": "Ninguém deu palpite neste vinho.",
    "blind.calls.grape.correct": "Casta certa",
    "blind.calls.grape.wrong": "Casta errada",
    "blind.calls.country.correct": "País certo",
    "blind.calls.country.wrong": "País errado",
    "blind.standings.title": "Classificação provisória",
    "blind.standings.final": "Classificação final",
    "blind.standings.row": "Palpites: {calls}, certos: {correct}",
    "blind.standings.points": "{points} pts",
    "blind.standings.rule":
      "Acertar a casta vale {grape} pontos, acertar o país {country}. Errar não custa nada.",
    "blind.results.open": "Ver os resultados",
    "blind.goal.title": "Meta semanal",
    "blind.goal.none.member": "Ainda sem meta semanal. Um admin pode escolher uma.",
    "blind.goal.none.manager":
      "Ainda sem meta semanal. Escolhe quantos palpites às cegas o grupo quer dar em conjunto esta semana.",
    "blind.goal.progress": "{calls} de {target} palpites às cegas esta semana",
    "blind.goal.reached": "Alcançada!",
    "blind.goal.remaining": "Faltam {n}",
    "blind.goal.correct": "{n} certos",
    "blind.goal.contributors": "Participaram",
    "blind.goal.target.label": "Meta por semana",
    "blind.goal.target": "{n} palpites",
    "blind.goal.off": "Desligar a meta semanal",
    "blind.goal.hint":
      "Conta os palpites às cegas de todos nas provas deste grupo. A contagem recomeça todas as segundas-feiras.",
    "blind.goal.error": "Não foi possível guardar a meta semanal.",
    "social.groups.log.goal": "O grupo alcançou a meta semanal de {target} palpites às cegas",
    "social.groups.log.goal.plain": "O grupo alcançou a meta semanal",
  },
} as const;
